/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listRooms = /* GraphQL */ `
  query ListRooms($searchId: String, $limit: Int) {
    listRooms(searchId: $searchId, limit: $limit) {
      items {
        id
        senderId
        receiverId
        senderName
        senderImageUrl
        receiverName
        receiverImageUrl
        lastMessage
        lastSenderId
        lastMessageRead
        firstMessageSent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMessagesForRoom = /* GraphQL */ `
  query ListMessagesForRoom(
    $roomId: ID
    $sortDirection: ModelSortDirection
    $username: String!
  ) {
    listMessagesForRoom(
      roomId: $roomId
      sortDirection: $sortDirection
      username: $username
    ) {
      items {
        id
        content {
          text
          sender
          __typename
        }
        createdAt
        updatedAt
        roomId
        status
        _maskApplied
        __typename
      }
      nextToken
      __typename
    }
  }
`;
